export const ADOBE_VIEW_REGEX_MAPPING_PT = 'ADOBE_VIEW_REGEX_MAPPING_PT';
